<template>
  <!--If user is NOT logged in, then wont be able to access admin section-->
  <div v-if="isLoggedIn == true">
    <!--Sidebar-->
    <v-navigation-drawer fixed app>
      <AdminSidebar></AdminSidebar>
      <!-- <DeleteMe></DeleteMe> -->
    </v-navigation-drawer>
    <!--Message that comes up with a status-->
    <v-container fill-height>
      <router-view @snackbarevent="updateSnackbar" />
    </v-container>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
import AdminSidebar from "@/pages/admin/components/general/sidebar/adminSidebar.vue";

import DeleteMe from "@/pages/admin/components/general/sidebar/deleteMe.vue";

export default {
  components:{
    AdminSidebar,
    DeleteMe
  },
  data() {
    return {
      updateSnackbar:"",
      routename: "",
      scrolled: false,
      drawer: { visible: null, clipped: false }
    };
  },
  methods: {
    ...mapMutations(["HISTORY_REMOVE"]),
    goToHistory() {
      this.$router.push(this.getHistory);
      this.HISTORY_REMOVE();
    },
    checkRouteName(name) {
      return this.routename == name;
    },
    handleScroll() {
      this.scrolled = window.scrollY > 0;
    }
  },
  computed: {
    ...mapGetters(["getHistory", "fullName", "isLoggedIn", "authStatus"])
  },
  mounted() {
    this.routename = this.$route.name;
    if (this.isLoggedIn && this.authStatus == "") {
      this.$store
        .dispatch("loginWithToken")
        .then(resp => {
          // setTimeout(() => this.$router.push("/"), 600);
        })
        .catch(err => {
          console.log(err);
        }
      );
    }
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>
